import { error } from "console";

export const getSampleData = () =>
    [
        {
            title: "Page Title Score",
            score: "",
            messages: [
                {
                    grade: "Poor" as "Poor",  
                    text: "You should add a Page Title",
                },
                {
                    grade: "Poor" as "Poor",  
                    text: "The focus keyword \"N/A\" doesn't appear in the Page Title",
                },
                {
                    grade: "Poor" as "Poor",  
                    text: "Put the focus keyword at the beginning of the Page Title",
                },
                {
                    grade: "Poor" as "Poor", 
                    text: "The Page Title is too short, 60 characters available. (0 of 60 characters used)",
                },
            ],
        },
        {
            title: "Meta Description Score",
            score: 25,
            messages: [
                {
                    grade: "Poor" as "Poor",  
                    text: "You should add a Meta description",
                },
                {
                    grade: "Poor" as "Poor",  
                    text: "The focus keyword doesn't appear in the Meta description",
                },
                {
                    grade: "Poor" as "Poor",  
                    text: "The Meta description is too short, 160 characters available. (0 of 160 characters used)",
                },
            ],
        },
        {
            title: "Content Score",
            score: 55,
            messages: [
                {
                    grade: "Poor" as "Poor",  
                    text: "You should add a H1",
                },
                {
                    grade: "Poor" as "Poor",  
                    text: "The focus keyword \"N/A\" doesn't appear in the H1",
                },
                {
                    grade: "Poor" as "Poor",  
                    text: "You should add text",
                },
                {
                    grade: "Poor" as "Poor",  
                    text: "Your text doesn't contain enough words, a minimum of 300 words is recommended",
                },
                {
                    grade: "Poor" as "Poor",  
                    text: "The focus keyword doesn't appear in first paragraph of the text",
                },
                {
                    grade: "Poor" as "Poor",  
                    text: "You should use the focus keyword more often, to improve the keyword density (0%)",
                },
                {
                    grade: "Poor" as "Poor",  
                    text: "You should add an image",
                },
                {
                    grade: "Poor" as "Poor",  
                    text: "The focus keyword \"N/A\" doesn't appear in the image name",
                },
                {
                    grade: "Poor" as "Poor",  
                    text: "The focus keyword \"N/A\" doesn't appear in the image Alt tag",
                },
                {
                    grade: "Poor" as "Poor",  
                    text: "Add relevant links to improve user experience and internal link structure",
                },
            ],
        },
    ];

    